<template>
  <v-menu
    v-model="rpcMethodMenu"
    :close-on-content-click="false"
    :nudge-width="240"
    :nudge-left="240"
    offset-y
    top
    >
    <template v-slot:activator="{ on }">
      <v-btn
      block
      v-on="on"
      >
        RPC-Methode
      </v-btn>
    </template>

    <v-card>
      <v-container fluid>
      <v-row>
          <v-col cols="12" class="text-center display-1">
          RPC-Methode
          </v-col>
      </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-select
                label="RPC-Methode"
                :items="rpcMethods"
                v-model="rpcMethodSelect"
                item-text="name"
                return-object
                @change="selectRpcMethodChanged"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                disabled
                label="Param names"
                :value="rpcMethodParameterName"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Params"
                hint="Als JSON Array"
                v-model="rpcMethodParams"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block
                @click="sendRpcMessage"
              >
                Sende Anfrage
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { OnionRpcMethods } from '@/helpers/OnionRpc/OnionRpcMethods';

export default {
  data: () => ({
    rpcMethods: OnionRpcMethods,
    rpcMethodMenu: false,
    rpcMethodSelect: OnionRpcMethods.find(x => x.name === 'GetRpcVersion'),
    rpcMethodParams: null,
    rpcMethodParameterName: '',
  }),

  methods: {
    selectRpcMethodChanged() {
      const method = this.rpcMethodSelect;
      this.$set(this, 'rpcMethodParameterName', JSON.stringify(method.parameter.map(x => x.name)));
      this.$set(this, 'rpcMethodParams', JSON.stringify(method.parameter.map(x => x.example).filter(x => x !== undefined)));
    },
    sendRpcMessage() {
      this.rpcMethodMenu = false;
      const msg = {
        method: this.rpcMethodSelect.value,
        params: this.rpcMethodParams ? JSON.parse(this.rpcMethodParams, (k, v) => {
          if (typeof v === 'string' ) {
            // FIXME(robin): no safe code: only works because currently no request has an array including strings or bytearray
            const param = this.rpcMethodSelect.parameter[k];
            if (param.types.includes('ByteArray')) {
              return Buffer.from(v, 'hex');
            }
          }
          return v;
        }) : [],
      };
      this.$emit('sendRpcMessage', msg);
    }
  },

  mounted() {
    this.selectRpcMethodChanged();
  },
};
</script>

<style>

</style>